import { gql } from '@apollo/client';

export const DELETE_LOCATION = gql`
	mutation DeleteHomeBase($baseId: ID!) {
		deleteCrewMemberHomeBase(id: $baseId) {
			__typename
		}
	}
`;
